import React, { useState } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import { RedNotify } from "../../helper/helper";

const ImageUploader = ({
  onUploadSuccess,
  onUploadStart,
  onUploadError,
  isPromotion = false,
  isChat = false,
  email,
}) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async ({ file }) => {
    const realFile = file.originFileObj || file;
    const formData = new FormData();
    formData.append("file", realFile);
    if (email) formData.append("email", email);
    if (isChat) {
      formData.append("isChat", isChat);
    }
    if (isPromotion) {
      formData.append("isPromotion", isPromotion);
    }

    setUploading(true);
    if (typeof onUploadStart === "function") onUploadStart();

    try {
      callApi(
        "POST",
        routes.s3Upload,
        formData,
        () => {},
        (res) => {
          if (res?.data?.key) {
            message.success(res.data.message || "Image uploaded successfully!");
            if (typeof onUploadSuccess === "function") {
              onUploadSuccess(res.data.key);
            }
          } else {
            message.error("Upload succeeded but no image URL returned.");
            if (typeof onUploadError === "function") onUploadError();
          }
        },
        (err) => {
          message.error(err?.message || "Upload failed.");
          if (typeof onUploadError === "function") onUploadError();
          RedNotify("Error uploading image");
        }
      ).finally(() => setUploading(false));
    } catch (err) {
      console.error("Upload error:", err);
      RedNotify("error uploading image");
      setUploading(false);
      if (typeof onUploadError === "function") onUploadError();
    }
  };

  return (
    <Upload
      customRequest={handleUpload}
      showUploadList={false}
      accept="image/*"
    >
      <Button icon={<UploadOutlined />} loading={uploading}>
        {uploading ? "Uploading..." : "Upload Image"}
      </Button>
    </Upload>
  );
};

export default ImageUploader;
